<template>

	<section class="container">

		<header class="container__header">

			<h1>Retter</h1>

			<router-link class="btn btn--md btn--primary primary--copper margin-t-50" :to="{name:'option.create'}">Tilføj ny ret</router-link>

		</header>

		<section class="container__body container__body--md">

			<section class="wrap--xsm__left margin-b-150">

				<form class="col-12">

					<label>Søgning efter ret?</label>

					<section class="search">

                        <VueFuse
                            class="col-12"
                            :list="optionsFiltered"
                            :default-all="true"
                            placeholder="Søg efter ret?"
                            :fuse-opts="searchOptions"
                            :map-results="true"
                            @fuse-results="handleResults">
						</VueFuse>

					</section>

				</form>

			</section>

			<section class="data-list">

				<header class="col-12 flex--space padding-b-25 border-b">

					<h1>Oversigt</h1>

					<section class="select-sm">

						<ws-select :options="choices" v-model="chosenOption"></ws-select>

					</section>

				</header>

				<transition name="fade" mode="out-in">

					<h4 v-if="isLoading" key="searching">Søger...</h4>

					<section class="no-result margin-t-25" v-if="optionsFiltered.length === 0 && !isLoading && options.length > 0" key="not-found" v-cloak>

						<i class="icon--lg fas fa-sad-tear"></i>

						<h4>Ingen resultater fundet</h4>

					</section>

				</transition>

				<transition-group name="fade" tag="section">

					<section class="item" v-for="option in results" :key="option.id">

						<section class="icon">

							<i class="icon--lg fas fa-tag"></i>

						</section>

						<section class="content">

							<h1 v-text="option.title"></h1>

							<ul>

								<li v-if="option.active">Status: Aktiv</li>
								<li v-else>Status: Inaktiv</li>
								<li>Pris: {{stripeAmount(option.price).amount}},-</li>

							</ul>

                            <ul class="products">
                                <template v-for="(product, index) in option.products">
                                    <li>{{product.title}}</li>
                                </template>
                            </ul>

						</section>

						<section class="link">

							<router-link :to="{name:'option.stats', params:{option:option.id}}">Administrer</router-link>

						</section>

					</section>

				</transition-group>

			</section>

		</section>

	</section>
</template>

<script>
	import {mapGetters} from 'vuex';
    import VueFuse from 'vue-fuse';
    export default {
        name: "option-index",
		data(){
            return {
                text:'',
				chosenOption:0,
				choices:[
                    'Aktive retter',
                    'Inaktive retter',
				],
                searchOptions: {
                    keys:['title']
                },
                results:[],
                isLoading: false,
			}
		},
        components:{
          VueFuse,
        },
		computed:{
            ...mapGetters(['options']),
			active(){
				return (this.chosenOption === 0) ? true:false;
			},
			optionsFiltered(){
			    if(this.options){
                    return this.options.filter(item =>  item.active === this.active);
                }
			    return [];
			}
        },
		methods:{
            handleResults (r) {
                this.results = r
            },
		},
		created(){
            this.$store.dispatch('getOptions');
		}
    }
</script>
